import React from "react";

import styled from "styled-components";
import Joyride from "react-joyride-react-19";
import { BloxButton } from "styled_components/Common/BloxButton";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
const TourStyle = styled.div`
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
  }
`;

export const AddUserTour = ({
  id,
  cypressId,
  handleTourCallback,
  tourSelected,
  setStepIndex,
  stepIndex,
}) => {
  const steps =
    tourSelected === "add-user"
      ? [
          {
            title: "Account Management",
            content:
              "The account management section is where you can manage users on your account.",
            placement: "center",
            locale: { skip: "S-K-I-P" },
            target: ".header-section",
            module: "account",
          },

          {
            target: "#add-user-button",
            module: "account",
            noBackButton: true,
            content: "You can click here to start the add user process.",
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Next"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("add-user-button").click();
                  setTimeout(() => setStepIndex(stepIndex + 1), 0);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: ".portrait-modal-container-user",
            content:
              "Here you will be able to enter the firstname , lastname and email for the user you want to create.",
            module: "account",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Next"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("id-firstname").click();
                  document.getElementById("id-firstname").value += "John";
                  document.getElementById("id-lastname").value += "Doe";
                  document.getElementById("id-email").value += "email@test.com";
                  //document.getElementById('button-1').click();
                  setTimeout(() => setStepIndex(stepIndex + 1), 500);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: "#button-1",
            content:
              "Once you have filled in all the information this button will activate and you can proceed.",
            module: "account",
            //noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("button-1").click();
                  setTimeout(() => setStepIndex(stepIndex + 1), 0);
                }}
                cypressId="continue-tour"
              />
            ),
          },

          {
            target: ".portrait-modal-container-user",
            content: "In this step you can request badge access for your user.",
            module: "account",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("access").click();
                  setStepIndex(stepIndex + 1);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: ".access",
            content: "For this tour we will choose no access.",
            module: "account",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("button-1").click();
                  setTimeout(() => setStepIndex(stepIndex + 1), 0);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: ".portrait-modal-container-user",
            content: "Here you will be able to review / edit and submit.",
            module: "account",
            noBackButton: true,
          },
          {
            target: "#button-1",
            content: "You will be able to submit your request here.",
            module: "account",
            noBackButton: true,
            locale: { next: "Finish" },
          },
        ]
      : [
          {
            title: "Account Management",
            content:
              "The account management section is where you can manage users on your account.",
            placement: "center",
            locale: { skip: "S-K-I-P" },
            target: ".header-section",
            module: "account",
          },

          {
            target: "#add-user-button",
            module: "account",
            content: "You can click here to start the add user process.",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("add-user-button").click();
                  setTimeout(() => setStepIndex(stepIndex + 1), 0);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: ".portrait-modal-container-user",
            content:
              "Here you will be able to enter the firstname , lastname and email for the user you want to create.",
            module: "account",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("id-firstname").click();
                  document.getElementById("id-firstname").value += "John";
                  document.getElementById("id-lastname").value += "Doe";
                  document.getElementById("id-email").value += "email@test.com";
                  //document.getElementById('button-1').click();
                  setTimeout(() => setStepIndex(stepIndex + 1), 500);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: "#button-1",
            content:
              "Once you have filled in all the information this button will activate and you can proceed.",
            module: "account",
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("button-1").click();
                  setTimeout(() => setStepIndex(stepIndex + 1), 0);
                }}
                cypressId="continue-tour"
              />
            ),
          },

          {
            target: ".portrait-modal-container-user",
            content: "In this step you can request badge access for your user.",
            module: "account",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("four").click();
                  setStepIndex(stepIndex + 1);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: ".four",
            content: "For this tour we will choose the Birmingham data center.",
            module: "account",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("button-1").click();
                  setTimeout(() => setStepIndex(stepIndex + 1), 0);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: ".portrait-modal-container-user",
            content:
              "Here you can choose if your user needs badge access for the selected data center(s).",
            module: "account",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("ga-dc-0").click();
                  setStepIndex(stepIndex + 1);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: "#button-1",
            content: "We will then move to the review screen.",
            module: "account",
            noBackButton: true,
            customNextButton: (
              <BloxButton
                className="buttons41"
                id="continue-tour"
                text="Continue"
                module="account"
                enabled={true}
                onClick={() => {
                  document.getElementById("button-1").click();
                  setStepIndex(stepIndex + 1);
                }}
                cypressId="continue-tour"
              />
            ),
          },
          {
            target: ".portrait-modal-container-user",
            content: "Here you will be able to review / edit and submit.",
            module: "account",
            noBackButton: true,
          },
          {
            target: "#button-1",
            content: "You will be able to submit your request here.",
            module: "account",
            noBackButton: true,
            locale: { next: "Finish" },
          },
        ];
  return (
    <TourStyle id={id} cypressId={cypressId}>
      <Joyride
        stepIndex={stepIndex}
        steps={steps}
        continuous={true}
        showProgress
        showSkipButton
        styles={{
          options: {
            zIndex: 5000,
          },
        }}
        tooltipComponent={JoyRideToolTip}
        run={tourSelected ? true : false}
        disableScrolling={true}
        callback={handleTourCallback}
        disableOverlayClose={true}
      />
    </TourStyle>
  );
};
